// Console pages take a numeric dashboard id. Public share pages take the dashboard's
// share hash, an itsdangerous URLSafeSerializer token "<payload>.<signature>" in
// URL-safe base64 (e.g. "MjU4OA.0OkypgNu8W_iptjZ6qycWSOjoAI"). Requiring a number
// on /share/ paths sent every share link to the 404 page.
const NUMERIC_ID = /^\d+$/;
const SHARE_HASH = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

export const isValidRouteId = (routePath, id) => {
  const value = id == null ? "" : String(id);
  return (routePath || "").startsWith("/share/")
    ? SHARE_HASH.test(value)
    : NUMERIC_ID.test(value);
};
